import { render, staticRenderFns } from "./assignvehicle.vue?vue&type=template&id=33426e20&scoped=true"
import script from "./assignvehicle.vue?vue&type=script&lang=js"
export * from "./assignvehicle.vue?vue&type=script&lang=js"
import style0 from "./assignvehicle.vue?vue&type=style&index=0&id=33426e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33426e20",
  null
  
)

export default component.exports